// Client conversion funnel → POST /api/subscription/conversion-event
// Server still owns plan state via Stripe; never trust client plan claims.
import api from './api';
import { analyticsReasonFromFeature } from '../utils/softPaywall';

const ALLOWED = new Set(['feature_hit', 'paywall_shown', 'checkout_started']);

/**
 * @param {'feature_hit'|'paywall_shown'|'checkout_started'} action
 * @param {{ feature?: string, toPlan?: string, metadata?: object }} opts
 */
export async function trackConversionEvent(action, opts = {}) {
  if (!ALLOWED.has(action)) return { success: false, skipped: true };

  const feature = opts.feature || 'client';
  const analyticsReason =
    opts.metadata?.reason ||
    analyticsReasonFromFeature(feature) ||
    undefined;

  const body = {
    action,
    feature,
    toPlan: opts.toPlan,
    metadata: {
      ...(opts.metadata || {}),
      ...(analyticsReason ? { reason: analyticsReason } : {}),
      clientReported: true,
    },
  };

  try {
    const res = await api.post('/subscription/conversion-event', body);
    return res.data || { success: true };
  } catch (err) {
    // Funnel telemetry must never break UX
    if (process.env.NODE_ENV === 'development') {
      console.warn('conversion-event failed', err?.response?.status || err.message);
    }
    return { success: false, error: err };
  }
}

export function trackPaywallShown(feature, extra = {}) {
  return trackConversionEvent('paywall_shown', {
    feature,
    toPlan: extra.toPlan,
    metadata: extra,
  });
}

export function trackCheckoutStarted(feature, toPlan, extra = {}) {
  return trackConversionEvent('checkout_started', {
    feature,
    toPlan,
    metadata: extra,
  });
}

export default {
  trackConversionEvent,
  trackPaywallShown,
  trackCheckoutStarted,
};
